import React from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import AdminLayout from '../../layouts/AdminLayout'
import {
  MdGroup,
  MdGroups2,
  MdGroups3,
  MdOutlineGroup,
  MdOutlineAnnouncement,
  MdOutlineMiscellaneousServices,
  MdOutlineEmail,
  MdOutlinePhone,
  MdOutlineWeb,
  MdArrowForward,
  MdDashboard,
  MdTrendingUp,
  MdAccessTime,
  MdCalendarToday
} from 'react-icons/md'
import { useEffect } from 'react'
import { useState } from 'react'
import { captialise_first_letter, currency } from '../../utils/helper'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, registerables } from "chart.js";
import { Doughnut, Bar, Line } from "react-chartjs-2";
import { FaHeart } from 'react-icons/fa'

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, ...registerables);


export default function AdminHomePage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user") // Still need to call for authentication check
  let user_data = useFetchUserData()

  const [userAnalyticData, setUserAnalyticData] = useState({})
  const [versionAnalyticData, setVersionAnalyticData] = useState({})

  const datetime = () => {
    let dateObj = new Date()
    let hours = dateObj.getHours()
    let minutes = dateObj.getMinutes()
    let day = dateObj.getDay()
    let date = dateObj.getDate()
    let month = dateObj.getMonth()
    let year = dateObj.getFullYear()
    const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    return {
      date: `${date} ${MONTHS[month].slice(0, 3)}`,
      time: `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`,
      day: DAYS[day],
      month: MONTHS[month],
      year
    }
  }

  const getGreeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return "Good morning"
    if (hour < 17) return "Good afternoon"
    return "Good evening"
  }

  const COLOR = "var(--primary)"
  const SIZE = 30

  useEffect(() => {
    fetchUserAnalytics()
    fetchVersionAnalytics()
  }, [])

  const fetchUserAnalytics = async () => {
    let endpoint = config.endpoint + "/analytics/data/users"
    let fetchResponse = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
    let data = await fetchResponse.json()
    if (data.status === 200) {
      setUserAnalyticData(data.data)
    }
  }

  const fetchVersionAnalytics = async () => {
    let endpoint = config.endpoint + "/version/analytics"
    let fetchResponse = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
    let data = await fetchResponse.json()
    if (data.status === 200) {
      setVersionAnalyticData(data.data)
    }
  }

  const shortcutCards = [
    {
      title: "View Members",
      description: "Manage church members and users",
      icon: <MdOutlineGroup size={32} color={COLOR} />,
      link: "/admin/users",
      bgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      title: "Create Announcement",
      description: "Send announcements to members",
      icon: <MdOutlineAnnouncement size={32} color={COLOR} />,
      link: "/admin/announcements",
      bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
      title: "Manage Services",
      description: "Schedule and organize services",
      icon: <MdOutlineMiscellaneousServices size={32} color={COLOR} />,
      link: "/admin/services",
      bgColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    },
    {
      title: "View Events",
      description: "Manage church events and activities",
      icon: <MdCalendarToday size={32} color={COLOR} />,
      link: "/admin/events",
      bgColor: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)"
    },
    {
      title: "Prayer Requests",
      description: "View and manage prayer requests",
      icon: <MdAccessTime size={32} color={COLOR} />,
      link: "/admin/prayer",
      bgColor: "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)"
    },
    // {
    //   title: "Library Items",
    //   description: "Manage library resources",
    //   icon: <MdTrendingUp size={32} color={COLOR} />,
    //   link: "/admin/library",
    //   bgColor: "linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)"
    // }
  ]

  return (
    <AdminLayout navSelected={"Dashboard"}>
      {/* Header Section */}
      <div className="mb-10">
        <div className="flex items-center gap-4 mb-6">
          <div className="flex items-center gap-3">
            {/* <MdAccessTime size={24} color={COLOR} /> */}
            <div className="flex flex-col">
              <p className="text-2xl font-bold text-gray-800">
                {getGreeting()}, {user_data?.first_name}!
              </p>
              <div className="flex items-center gap-4 text-gray-600 mt-1">
                <div className="flex items-center gap-2">
                  <MdCalendarToday size={16} />
                  <span>{datetime().day}, {datetime().date} {datetime().month} {datetime().year}</span>
                </div>
                {/* <div className="flex items-center gap-2">
                  <MdAccessTime size={16} />
                  <span>{datetime().time}</span>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Analytics Section */}
      {Object.keys(userAnalyticData).length > 0 && (
        <>
          {/* Stats Cards */}
          <div className="mb-8">
            <div className="flex items-center gap-2 mb-6">
              <MdTrendingUp size={24} color={COLOR} />
              <h2 className="text-xl font-semibold text-gray-800">Overview</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-blue-500">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-3xl font-bold text-gray-800">{currency(userAnalyticData?.total_users)}</p>
                    <p className="text-gray-600 mt-1">Total Users</p>
                  </div>
                  <div className="bg-blue-100 p-3 rounded-full">
                    <MdGroup size={SIZE} color="#3B82F6" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-green-500">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-3xl font-bold text-gray-800">{currency(userAnalyticData?.members)}</p>
                    <p className="text-gray-600 mt-1">Registered Members</p>
                  </div>
                  <div className="bg-green-100 p-3 rounded-full">
                    <MdGroups2 size={SIZE} color="#10B981" />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-purple-500">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-3xl font-bold text-gray-800">{currency(userAnalyticData?.guest_users)}</p>
                    <p className="text-gray-600 mt-1">Guest Users</p>
                  </div>
                  <div className="bg-purple-100 p-3 rounded-full">
                    <MdGroups3 size={SIZE} color="#8B5CF6" />
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-yellow-500">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-3xl font-bold text-gray-800">{currency(userAnalyticData?.missions_count)}</p>
                    <p className="text-gray-600 mt-1">Missions</p>
                  </div>
                  <div className="bg-yellow-100 p-3 rounded-full">
                    <MdOutlineMiscellaneousServices size={SIZE} color="#F59E0B" />
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-md p-6 border-l-4 border-red-500">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-3xl font-bold text-gray-800">{currency(Object.values(userAnalyticData?.aol_by_act)?.reduce((a, b) => a + b, 0))}</p>
                    <p className="text-gray-600 mt-1">Acts of Love</p>
                  </div>
                  <div className="bg-red-100 p-3 rounded-full">
                    <FaHeart size={SIZE} color="#EF4444" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content Grid - Analytics, Quick Actions and Support */}
          <div className="flex flex-col lg:flex-row gap-6 mb-8">
            {/* Charts Section - Main content area */}
            <div className="flex-1 lg:flex-[2]">
              <div className="flex items-center gap-2 mb-6">
                <MdDashboard size={24} color={COLOR} />
                <h2 className="text-xl font-semibold text-gray-800">Overview</h2>
              </div>

              {/* Charts Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Pie Chart - Devices */}
                <div className="bg-white rounded-xl shadow-md p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">Device Sessions</h3>
                  <div className="h-64">
                    <Doughnut
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            position: 'bottom'
                          }
                        }
                      }}
                      data={{
                        labels: Object.keys(userAnalyticData?.users_by_device)?.map((device) => captialise_first_letter(device)),
                        datasets: [
                          {
                            data: Object.values(userAnalyticData?.users_by_device),
                            backgroundColor: ["#3B82F6", "#EF4444", "#F59E0B", "#10B981", "#06B6D4", "#8B5CF6"],
                            borderWidth: 0
                          },
                        ],
                      }}
                    />
                  </div>
                </div>

                {/* Pie Chart - User Types */}
                <div className="bg-white rounded-xl shadow-md p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">User Distribution</h3>
                  <div className="h-64">
                    <Doughnut
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            position: 'bottom'
                          }
                        }
                      }}
                      data={{
                        labels: ["Members", "Guests"],
                        datasets: [
                          {
                            data: [userAnalyticData?.members, userAnalyticData?.guest_users],
                            backgroundColor: ["#3B82F6", "#EF4444"],
                            borderWidth: 0
                          },
                        ],
                      }}
                    />
                  </div>
                </div>

                {/* Pie Chart - App Versions */}
                <div className="bg-white rounded-xl shadow-md p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">App Version Usage</h3>
                  <div className="h-64">
                    {versionAnalyticData?.version_distribution && versionAnalyticData.version_distribution.length > 0 ? (
                      <Doughnut
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            legend: {
                              position: 'bottom'
                            },
                            tooltip: {
                              callbacks: {
                                label: function (context) {
                                  const version = versionAnalyticData.version_distribution[context.dataIndex];
                                  return `${version.label}: ${version.value} devices (${version.percentage}%)`;
                                }
                              }
                            }
                          }
                        }}
                        data={{
                          labels: versionAnalyticData?.version_distribution?.map((version) => version.label),
                          datasets: [
                            {
                              data: versionAnalyticData?.version_distribution?.map((version) => version.value),
                              backgroundColor: ["#3B82F6", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#06B6D4", "#F97316", "#EC4899"],
                              borderWidth: 0
                            },
                          ],
                        }}
                      />
                    ) : (
                      <div className="h-full flex items-center justify-center">
                        <div className="text-center">
                          <div className="bg-gray-100 rounded-full p-8 mb-4 inline-block">
                            <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 00-2-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 00-2 2" />
                            </svg>
                          </div>
                          <p className="text-gray-500 text-sm">No version data available yet</p>
                          <p className="text-gray-400 text-xs mt-1">Data will appear once users start using the mobile app</p>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mt-4 text-center">
                    <p className="text-sm text-gray-600">
                      Total devices with version data: {versionAnalyticData?.total_users_with_versions || 0}
                    </p>
                  </div>
                </div>

                {/* Line Chart - Weekly Users */}
                <div className="bg-white rounded-xl shadow-md p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">Weekly Usage</h3>
                  <div className="h-64">
                    <Line
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: false
                          }
                        },
                        scales: {
                          y: {
                            beginAtZero: true
                          }
                        }
                      }}
                      data={{
                        labels: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                        datasets: [
                          {
                            label: "Weekly Users",
                            data: Object.values(userAnalyticData?.daily_users),
                            borderColor: "#3B82F6",
                            backgroundColor: "rgba(59, 130, 246, 0.1)",
                            fill: true,
                            tension: 0.4
                          },
                        ],
                      }}
                    />
                  </div>
                </div>

                {/* Bar Chart - Monthly Users */}
                <div className="bg-white rounded-xl shadow-md p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">Monthly Usage</h3>
                  <div className="h-64">
                    <Bar
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                          legend: {
                            display: false
                          }
                        },
                        scales: {
                          y: {
                            beginAtZero: true
                          }
                        }
                      }}
                      data={{
                        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                        datasets: [
                          {
                            label: "Monthly Users",
                            data: Object.values(userAnalyticData?.monthly_users),
                            backgroundColor: "#3B82F6",
                            borderRadius: 8
                          },
                        ],
                      }}
                    />
                  </div>
                </div>
                {/* Bar Chart - Missions Per Month */}
                <div className="bg-white rounded-xl shadow-md p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-4">Missions</h3>
                  <div className="h-64">
                    <Bar
                      options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: { legend: { display: false } },
                        scales: { y: { beginAtZero: true } }
                      }}
                      data={{
                        labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                        datasets: [
                          {
                            label: "Missions",
                            data: Object.values(userAnalyticData?.missions_per_month || {}),
                            backgroundColor: "#F59E0B",
                            borderRadius: 8
                          },
                        ],
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl shadow-md p-6 mt-6">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">AOL Completions by Act</h3>
                <div className="h-64">
                  <Bar
                    options={{
                      responsive: true,
                      maintainAspectRatio: false,
                      plugins: { legend: { display: false } },
                      scales: { y: { beginAtZero: true } }
                    }}
                    data={{
                      labels: Object.keys(userAnalyticData?.aol_by_act || {}),
                      datasets: [{ label: 'Completions', data: Object.values(userAnalyticData?.aol_by_act || {}), backgroundColor: '#06B6D4' }]
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Sidebar - Quick Actions and Support */}
            <div className="w-full lg:w-80 flex flex-col gap-6">
              {/* Quick Actions Section */}
              <div>
                <div className="flex items-center gap-2 mb-4">
                  <MdDashboard size={20} color={COLOR} />
                  <h3 className="text-lg font-semibold text-gray-800">Quick Actions</h3>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3">
                  {shortcutCards.map((card, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer transform hover:-translate-y-0.5"
                      onClick={() => navigate(card.link)}
                      style={{
                        background: card.bgColor,
                        color: 'white'
                      }}
                    >
                      <div className="p-3">
                        <div className="flex items-center justify-between mb-2">
                          <div className="bg-white bg-opacity-20 p-1.5 rounded">
                            {React.cloneElement(card.icon, { size: 16 })}
                          </div>
                          <MdArrowForward size={14} className="opacity-70" />
                        </div>
                        <h4 className="text-sm font-semibold mb-0.5">{card.title}</h4>
                        <p className="text-xs opacity-90 leading-tight">{card.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  )
}
